export const services = [
  {
    name: '50 Minute Facial',
    short:
      'Our signature facial includes an in-depth skin analysis, followed by personalized',
    long: 'Our signature facial includes an in-depth skin analysis, followed by personalized treatments using our exclusive HeydayPro™ products. Your facial will likely include exfoliation, extractions, facial massage, and aromatherapy.',
    isLaser: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
  },
  {
    name: 'Laser Facial',
    short:
      'Go deep with a comprehensive, 50-minute laser treatment that is calibrated',
    long: `Go deep with a comprehensive, 50-minute laser treatment that is calibrated to your unique skin type using Skintel®, the world's first Melanin Reader™. Safe for all skin types.`,
    isLaser: true,
    hideMemberPrice: false,
    isMembershipPrice: true,
  },
  {
    name: 'Laser Lite + Consultation',
    short: `We will analyze your skin, determine the right Laser settings based on your skin type and goals, and conduct an introductory laser treatment to understand your skin's response. You'll leave with a personalized treatment plan for optimal results.`,

    long: `We will analyze your skin, determine the right Laser settings based on your skin type and goals, and conduct an introductory laser treatment to understand your skin's response. You'll leave with a personalized treatment plan for optimal results.

This introductory price cannot be combined with any other first-time facial offer.`,
    isLaser: true,
    hideMemberPrice: true,
    isMembershipPrice: false,
  },
  {
    name: 'Microneedling',
    label: 'The Microneedling Facial',
    short:
      'A 50-minute custom Microneedling facial powered by the only FDA-cleared',
    long: `A 50-minute custom Microneedling facial powered by the only FDA-cleared, digital device, Dermapen, for optimal precision that delivers superior safety and results. Improve acne, brighten pigmentation, minimize pores and smooth fine lines and scarring. Minimally invasive. Immediate results.`,
    isLaser: false,
    isMicro: true,
    hideMemberPrice: false,
    isMembershipPrice: true,
  },
]
